// extracted by mini-css-extract-plugin
export default {"title":"f627b2d7bb","bld":"d4b9cc8f76"};